// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.user-details-trend-chart.chart-container[data-v-9dd22040] {
  max-height: 264px;
  overflow: auto;
}`, "",{"version":3,"sources":["webpack://./js/modules/historical/user-details-view/charts/userDetailsTrendChart.vue","webpack://./userDetailsTrendChart.vue"],"names":[],"mappings":"AACA;EACE,iBAAA;EACA,cAAA;ACAF","sourcesContent":["\n.user-details-trend-chart.chart-container {\n  max-height: 264px; // this should be MAX_HEIGHT + 10px\n  overflow: auto;\n}\n",".user-details-trend-chart.chart-container {\n  max-height: 264px;\n  overflow: auto;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
